import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Content from '../content/Content';
import { styled } from '@mui/material/styles';
import { Alert, FilledInput, Grid, IconButton, InputAdornment, InputLabel, Snackbar } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const API = require("../../data/network/API");

function Copyright(props) {
  return (
    <Stack spacing={4} sx={{mt:2}}>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {new Date().getFullYear()} {'© SwitchPoint SA. de CV. All rights reserved'}
      </Typography>
      <Box
          alignSelf= 'center'
          component="img"
          sx={{
            height: 32,
            width: 80,
          }}
          alt="officia logo."
          src="/static/sw.png"
        />
    </Stack>
  );
}

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  backgroundColor: 'transparent',
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

function SignInCard() {
  const navigate = useNavigate();

  const {state} = useLocation();

  const [snackbarState, setSnackbarState] = React.useState({open:false,message:"",status:"info"});
  const [showPassword, setShowPassword] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  
  const handleSubmit = async(event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    const code = data.get('code')

    if(code.length==0){
      setSnackbarState({open: true, message: "Ingresa el codigo", status: "warning"})
      return
    }

    const requestBody = {
      correo: state.correo,
      codigo: code,
    }
  
    setOpen(true);
    const response = await API.patchVerificationCode(requestBody)
    setOpen(false);

    if(response.status == 201){
        console.log(response.data)
        navigate('/registry',{ state: { correo: state.correo }});
    }else{
      setSnackbarState({open:true, message: response.message, status:"error"})
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (
    <Card >
       <Box
        alignSelf= 'center'
        component="img"
        sx={{
          height: 256,
          width: 256,
        }}
        alt="officia logo."
        src="/static/sign_in_ background.png"
      />
      <Typography
        variant="h5"
        sx={{fontWeight:"bolder"}}
      >
        Revisa tu correo electrónico
      </Typography>
      <Typography
        variant="body2" color="text.secondary"
      >
        Recibirás un correo electrónico con un codigo de verficación. Para cualquier aclaración, debajo de este texto podrás ver tu número de confirmación.
      </Typography>
      <Typography
        variant="h7"
        sx={{textAlign:"center"}}
      >
        Numero de confirmación
      </Typography>
      <Typography
        variant="body"
        sx={{textAlign:"center", background:"gray", color:"black"}}
      >
        {state.confirmation_code}
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>

        <FormControl fullWidth variant="filled" color='secondary'sx={{mt:2}}>
        <InputLabel htmlFor="outlined-adornment-password">Codigo</InputLabel>
        <FilledInput
          id="code"
          name="code"
          label="Ingresa codigo"
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        </FormControl>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color='secondary'
          sx={{ mt: 3, mb: 2 }}
        >
          verificar
        </Button>
        <Grid container>
          <Grid item xs>
            <Stack spacing={2}>
             
              <Typography variant="body2" color="text.secondary" align="center">
              Al verificar, aceptas nuestras condiciones de uso y venta.
              </Typography>
              <Typography align='center'>
                <Link href="#" variant="body2" color={"secondary"} >
                  ¿Necesitas ayuda?
                </Link>
              </Typography>
            </Stack>
          </Grid>
          <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity={snackbarState.status}
              variant="filled"
            >
              {snackbarState.message}
            </Alert>
          </Snackbar>
        </Grid>
        <Copyright/>
      </Box> 
    </Card>
  );
}

export default function VerificationCode() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            //marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 0, sm: 4 },
              m: 'auto',
            }}
          >
            <Content />
            <SignInCard />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}